const $e2e9b6f8fce6e381$var$loader = document.querySelector(".loader");
const $e2e9b6f8fce6e381$var$docContent = document.querySelector("body");
const $e2e9b6f8fce6e381$export$bae05954399fae16 = function() {
    // loader.style.display = 'none'
    $e2e9b6f8fce6e381$var$docContent.style.overflow = "hidden";
};
const $e2e9b6f8fce6e381$export$5303cf8b8f096deb = function() {
    $e2e9b6f8fce6e381$var$loader.innerHTML = "";
    $e2e9b6f8fce6e381$var$loader.parentNode.removeChild($e2e9b6f8fce6e381$var$loader);
    $e2e9b6f8fce6e381$var$docContent.style.overflow = "initial";
};


const $245f00cada52a337$var$dropItems = document.querySelector(".dropdown-items");
const $245f00cada52a337$var$arrow = document.querySelector(".dropdown-arrow");
const $245f00cada52a337$export$a6ecdba4b07adec7 = (mainButton)=>{
    mainButton.addEventListener("click", ()=>{
        $245f00cada52a337$var$dropItems.classList.toggle("is-active");
        $245f00cada52a337$var$arrow.classList.toggle("rotation");
    });
};


const $91b675fef38296b2$var$menuIcon = document.querySelector("#mobile-menu");
const $91b675fef38296b2$var$mobileMenu = document.querySelector(".navbar ul");
const $91b675fef38296b2$var$mobileTabs = document.querySelectorAll(".navbar ul li a");
const $91b675fef38296b2$var$removeMenuCover = function() {
    $91b675fef38296b2$var$menuIcon.classList.remove("is-active");
    $91b675fef38296b2$var$mobileMenu.classList.remove("mobile-active");
};
const $91b675fef38296b2$export$95ef60e3a6ad017b = function() {
    $91b675fef38296b2$var$menuIcon.addEventListener("click", (e)=>{
        $91b675fef38296b2$var$menuIcon.classList.toggle("is-active");
        $91b675fef38296b2$var$mobileMenu.classList.toggle("mobile-active");
        [
            ...$91b675fef38296b2$var$mobileTabs
        ].forEach((tab)=>{
            tab.addEventListener("click", $91b675fef38296b2$var$removeMenuCover);
        });
    });
};


const $1330686bdbad7f7e$var$cursor = document.querySelector("#cursor");
let $1330686bdbad7f7e$var$mouse = {
    x: 300,
    y: 300
};
let $1330686bdbad7f7e$var$pos = {
    x: 0,
    y: 0
};
const $1330686bdbad7f7e$var$speed = 0.15 // between 0 and 1
;
const $1330686bdbad7f7e$var$updatePosition = ()=>{
    $1330686bdbad7f7e$var$pos.x += ($1330686bdbad7f7e$var$mouse.x - $1330686bdbad7f7e$var$pos.x) * $1330686bdbad7f7e$var$speed;
    $1330686bdbad7f7e$var$pos.y += ($1330686bdbad7f7e$var$mouse.y - $1330686bdbad7f7e$var$pos.y) * $1330686bdbad7f7e$var$speed;
    $1330686bdbad7f7e$var$cursor.style.transform = "translate3d(" + $1330686bdbad7f7e$var$pos.x + "px ," + $1330686bdbad7f7e$var$pos.y + "px, 0)";
};
const $1330686bdbad7f7e$var$updateCoordinates = (e)=>{
    $1330686bdbad7f7e$var$mouse.x = e.clientX;
    $1330686bdbad7f7e$var$mouse.y = e.clientY;
};
const $1330686bdbad7f7e$export$185d1f0722e636b2 = function loop() {
    window.addEventListener("mousemove", $1330686bdbad7f7e$var$updateCoordinates);
    $1330686bdbad7f7e$var$updatePosition();
    requestAnimationFrame(loop);
};


const $2b9de3abd94a12e9$export$4e7161e8eac426ef = (e)=>{
    let target;
    if (e.target.tagName === "DIV" && e.target.className === "" || e.target.tagName === "P" || e.target.tagName === "SPAN") {
        if (e.target.tagName !== "DIV") target = e.target.parentElement;
        else target = e.target;
        target.classList.toggle("expandDiv");
        target.children[2].classList.toggle("rotation");
        // console.log(target.children)
        setTimeout(async ()=>{
            await target.children[1].classList.toggle("deactivate");
        }, 200);
    }
};


class $e79e95853a17f97c$var$TextView {
    _data;
    _checkValue;
    _moveValue = 0;
    transiteText(data) {
        if (!data) return new Error("text not defined");
        // this._data = data.cloneNode(true) //Cloning no ref
        this._data = data;
        // console.log(this._moveValue, this.getTranslateXY(this._data.children[0]))
        // this._data.children[0].style.transform = `translateY(100%)`
        // console.log(this._data.children[0])
        this._checkValue = this._data.classList.contains("upper") ? 33.34 : -33.34;
        this._moveValue = this.getTranslateXY(this._data.children[0], this._data);
        // console.log(this._moveValue)
        if (this._moveValue === this._checkValue * 2) {
            this._data.children[0].style.transform = `translateY(0%)`;
            this._moveValue = 0;
        } else {
            this._moveValue += this._checkValue;
            this._data.children[0].style.transform = `translateY(${this._moveValue}%)`;
        }
    // console.log(this._moveValue)
    }
    getTranslateXY(element, parentElement) {
        const translateStyle = element.style.transform;
        // console.log(
        //   translateStyle.slice(
        //     translateStyle.indexOf('('),
        //     translateStyle.indexOf('%')
        //   ),
        //   translateStyle
        // )
        const styleVal = translateStyle.slice(translateStyle.indexOf("(") + 1, translateStyle.indexOf("%")) * 1;
        // console.log(styleVal)
        // const style = window.getComputedStyle(element)
        // const matrex = style.getPropertyValue('transform')
        // const matrexArr = matrex.split(', ')
        // return parseInt(matrexArr[5])
        // const matrix = new WebKitCSSMatrix(style.transform)
        // return {
        //   translateX: matrix.m41,
        //   translateY: matrix.m42,
        // }
        return styleVal;
    }
}
var $e79e95853a17f97c$export$2e2bcd8739ae039 = new $e79e95853a17f97c$var$TextView();


const $f81c94027aaef130$var$options = {
    // root: document.querySelector('body'),
    rootMargin: "0px",
    // threshold: 0.5,
    threshold: [
        0.5,
        1
    ]
};
const $f81c94027aaef130$var$switchClasses = (entry, targetCollection, classOne, classTwo)=>{
    Array.from(targetCollection).forEach((target, index)=>{
        if (index % 2 === 0) target.classList.toggle(classOne, entry.isIntersecting);
        else target.classList.toggle(classTwo, entry.isIntersecting);
    });
};
const $f81c94027aaef130$var$callback = (entries, observer)=>{
    entries.forEach((entry)=>{
        if (entry.target.classList.contains("about-services")) {
            // console.log('check: ', entry)
            $f81c94027aaef130$var$switchClasses(entry, entry.target.children[2].children, "servicesDown", "servicesUp");
            const images = document.querySelectorAll(".about-services .element");
            $f81c94027aaef130$var$switchClasses(entry, images, "imageDown", "imageUp");
        //   Array.from(images).forEach((target, index) => {
        //     if (index % 2 === 0)
        //       target.classList.toggle('imageDown', entry.isIntersecting)
        //     else target.classList.toggle('imageUp', entry.isIntersecting)
        //   })
        } else if (entry.target.classList.contains("partners-section")) // console.log(entry.target.children[1])
        Array.from(entry.target.children[1].children).forEach((target, index)=>{
            target.classList.toggle("details", entry.isIntersecting);
        });
        else if (entry.target.classList.contains("intro-section")) {
            const images = document.querySelectorAll(".intro-section .element");
            $f81c94027aaef130$var$switchClasses(entry, images, "imageDown", "imageUp");
        }
    });
};
var $f81c94027aaef130$export$2e2bcd8739ae039 = new IntersectionObserver($f81c94027aaef130$var$callback, $f81c94027aaef130$var$options);


const $3909f9b280ec3695$var$textController = (data)=>{
    setInterval(()=>{
        (0, $e79e95853a17f97c$export$2e2bcd8739ae039).transiteText(data);
    }, 2000);
};
const $3909f9b280ec3695$var$controller = ()=>{
    const targetEl = document.querySelectorAll(".section");
    const faqDetails = document.querySelector(".faq-details");
    const upperText = document.querySelector(".intro-text .upper");
    const lowerText = document.querySelector(".intro-text .lower");
    const loginButton = document.querySelector(".main-button");
    // Menu controll
    (0, $91b675fef38296b2$export$95ef60e3a6ad017b)();
    // Intro text
    $3909f9b280ec3695$var$textController(lowerText);
    $3909f9b280ec3695$var$textController(upperText);
    // Login
    (0, $245f00cada52a337$export$a6ecdba4b07adec7)(loginButton);
    // cursor
    requestAnimationFrame((0, $1330686bdbad7f7e$export$185d1f0722e636b2));
    // IntersectionObserverAPI
    targetEl.forEach((e)=>(0, $f81c94027aaef130$export$2e2bcd8739ae039).observe(e));
    // faq
    faqDetails.addEventListener("click", (e)=>{
        (0, $2b9de3abd94a12e9$export$4e7161e8eac426ef)(e);
    });
};
document.querySelector("main").style.display = "none";
// spinner
window.onload = function() {
    (0, $e2e9b6f8fce6e381$export$bae05954399fae16)();
    (0, $e2e9b6f8fce6e381$export$5303cf8b8f096deb)();
    // setTimeout(async () => {
    // }, 3000)
    document.querySelector("main").style.display = "block";
    $3909f9b280ec3695$var$controller();
};


//# sourceMappingURL=index.d281ae8c.js.map
